import moment from "moment";
import { utils, writeFileXLSX } from "xlsx";

function formatCurrency(value) {
  const num = Number(value) || 0;
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

function formatDate(value) {
  if (!value) return moment().format("DD/MM/YYYY");
  return moment(value).format("DD/MM/YYYY");
}

function buildFormularioDevolucaoRows(detail) {
  const valor = formatCurrency(detail.ValorTotalNota);

  return [
    ["Formulário de Devolução", "", "", ""],
    [],
    ["Data Formulário", formatDate(detail.DataSolicitacao), "", ""],
    ["Responsável", detail.Responsavel || "Dolly", "", ""],
    ["Solicitante Devolução", detail.NomeUsuarioSolicitante || "", "", ""],
    ["Número Protocolo", detail.NumeroProtocolo || "", "", ""],
    ["Código de Cliente", detail.CodigoErpCliente || "", "", ""],
    ["Razão Social", detail.RazaoSocial || "", "", ""],
    ["Código de Fornecedor", "solicitado", "", ""],
    ["Onde encontra-se a mercadoria", detail.Origem || "", "", ""],
    ["Tipo de Devolução", "Total", "", ""],
    ["Devolução com NF", "Nota Karsten", "", ""],
    ["Número de NF Karsten", detail.NumeroNota || "", "", ""],
    [
      "Número de NF Retorno (Cliente)",
      detail.NumeroNotaDevolucao || "",
      "",
      "",
    ],
    ["Quant. Caixas | Volumes", detail.Volume || 0, "", ""],
    ["Valor Da Devolução", valor, "", ""],
    ["Motivo da Devolução", detail.MotivoDevolucao || "", "", ""],
    ["Motivo do Lançamento", detail.MotivoLancamento || "", "", ""],
    [],
    [
      "Itens da Devolução (caso seja nota completa não é necessário o preenchimento)",
      "",
      "",
      "",
    ],
    ["Código Produto", "Quantidade", "Descrição/Motivo", ""],
    ...(detail.Itens || []).map((item) => [
      item.IdProduto,
      item.Quantidade,
      item.NomeProduto,
      "",
    ]),
    [],
    [
      "Salvar Formulario na pasta  K:\\CRC\\Publico\\CRC x Expedição\\Formulário de Devolução - Nomear com numero da NF de Origem e Razão Social do Cliente. Para devoluções com retorno preencher a planilha no local K:\\CRC\\Publico\\CRC x Expedição\\Acompanhamento de devoluções em processo de retorno.",
      "",
      "",
      "",
    ],
    ["CNPJ  82.640.558/0001-04 - Karsten S.A.", "", "", ""],
    [
      "Rua Johann Karsten, 260 – Testo Salto – CEP 89074-700 – Blumenau -SC -  Brasil – Tel.: 0800 647 4404",
      "",
      "",
      "",
    ],
    ["www.karstensa.com.br - e-mail: crc@karsten.com.br", "", "", ""],
  ];
}

export function generateFormularioDevolucaoReport(detail) {
  const rows = buildFormularioDevolucaoRows(detail);
  const ws = utils.aoa_to_sheet(rows);
  ws["!cols"] = [{ wch: 35 }, { wch: 45 }, { wch: 20 }, { wch: 20 }];
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, "Formulário Devolução");
  const fileName = `Formulario_Devolucao_NF_${detail.NumeroNota}_${moment().format("YYYYMMDD_HHmm")}.xlsx`;
  writeFileXLSX(wb, fileName);
}

const CRC_HEADER = [
  "Data",
  "Solicitante",
  "Código de Cliente:",
  "Razão Social:",
  "Onde encontra-se a mercadoria:",
  "Transportadora",
  "Tipo de Devolução:",
  "Devolução com NF:",
  "Numero de NF Karsten:",
  "Numero de NF Retorno (Cliente):",
  "Descrição",
  "Quant. Caixas | Volumes:",
  "Valor Da Devolução:",
  "Motivo da Devolução:",
  "Motivo do Lançamento:",
  "Lançado?",
];

function buildCrcDataRow(detail) {
  const valor = Number(detail.ValorTotalNota || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return [
    formatDate(detail.DataSolicitacao),
    detail.NomeUsuarioSolicitante || "",
    detail.CodigoErpCliente || "",
    detail.RazaoSocial || "",
    detail.Origem || "",
    "",
    "Total",
    "Nota Karsten",
    detail.NumeroNota || "",
    detail.NumeroNotaDevolucao || "",
    "",
    detail.Volume || 0,
    valor,
    detail.MotivoDevolucao || "",
    detail.MotivoLancamento || "",
    detail.NumeroNotaCredito ? "Sim" : "Não",
  ];
}

function buildRelatorioFinanceiroRows(detail) {
  return [CRC_HEADER, buildCrcDataRow(detail)];
}

export function generateRelatorioFinanceiroReport(detail) {
  const rows = buildRelatorioFinanceiroRows(detail);
  const ws = utils.aoa_to_sheet(rows);
  ws["!cols"] = Array(16).fill({ wch: 22 });
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, "CRC Financeiro");
  const fileName = `Relatorio_CRC_Financeiro_NF_${detail.NumeroNota}_${moment().format("YYYYMMDD_HHmm")}.xlsx`;
  writeFileXLSX(wb, fileName);
}
